// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"resources_lang_fr_json":1,"resources_lang_it_json":1}[chunkId]) return "js/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};